export const langID = {
  // grouped translations
  error: {},
  lang: {
    indonesia: 'Indonesia',
    english: 'English',
  },

  menu: {
    candidate_management: 'MANAJEMEN KANDIDAT',
    jobs: 'LOWONGAN PEKERJAAN',
    settings: 'PENGATURAN',
    users: 'PENGGUNA',
    school_data: 'Data Sekolah',
    master_data: 'MASTER DATA',
    job_status: 'Status Pekerjaan',
    skill: 'Keahlian',
    school_name: 'Nama Sekolah',
    school_location: 'Lokasi Sekolah',
    job_position: 'Posisi Pekerjaan',
    interview_forms: 'Form Interview',
    offering_letter_forms: 'Form Surat Penawaran',
    job_kind: 'Jenis Pekerjaan',
    register: 'Daftar',
    login: 'Masuk',
    welcome_name: 'Selamat datang {{name}}!',
    hello_name: 'Hello, {{name}}',
    staff_personalia: 'Staff Personalia',
    admin: 'Admin',
    user: 'User',
    archive: 'ARSIP',
    job_archive: 'Arsip Lowongan',
    candidate_archive: 'Arsip Lamaran',
    notifications: 'Notifikasi',
  },

  form: {
    foundation_name: 'Nama Yayasan',
    foundation_address: 'Alamat Yayasan',
    phone_number: 'Nomor Telepon',
    website: 'Situs Web',
    vision: 'Visi',
    mission: 'Misi',
    profile: 'Profile',
    logo: 'Logo',
    choose_file: 'Pilih File',
    saved: 'Data tersimpan',
    submitted: 'Form berhasil dikirim',
    description: 'Deskripsi',
    name: 'Nama',
    search: 'Cari',
    birth_date: 'Tanggal Lahir',
    password: 'Password',
    email: 'Email',
    title: 'Posisi Pekerjaan',
    school: 'Sekolah',
    placement: 'Penempatan',
    location: 'Lokasi',
    job_position: 'Jenis Pekerjaan',
    status: 'Status',
    skill: 'Keahlian',
    ended_at: 'Berakhir Pada',
    minimum_salary: 'Gaji Minimal',
    maximum_salary: 'Gaji Maksimal',
    job_description: 'Deskripsi Pekerjaan',
    job_status_description: 'Deskripsi Status Pekerjaan',
    step: 'Tahap',
    job_positions: 'Jenis Pekerjaan',
    select_job_positions: 'Pilih Posisi Pekerjaan',
    form_builder: 'Pembuat Form',
    add_page: 'Tambah Halaman',
    page: 'Halaman',
    untitled_page: 'Halaman Tanpa Judul',
    page_title: 'Judul Halaman',
    remove_page: 'Hapus Halaman',
    questions: 'Pertanyaan',
    add_question: 'Tambah Pertanyaan',
    collapse_all: 'Ciutkan Semua',
    expand_all: 'Perluas Semua',
    question: 'Pertanyaan',
    question_type: 'Tipe Pertanyaan',
    question_category: 'Kategori Pertanyaan',
    question_text: 'Teks Pertanyaan',
    enter_question_text: 'Masukkan teks pertanyaan',
    required: 'Wajib',
    options: 'Pilihan',
    add_option: 'Tambah Pilihan',
    option: 'Pilihan',
    remove: 'Hapus',
    visibility_logic: 'Logika Visibilitas',
    logic_functionality_will_be_implemented_here: 'Fungsionalitas logika akan diimplementasikan di sini',
    no_questions_added_yet: 'Belum ada pertanyaan yang ditambahkan',
    add_first_question: 'Tambah Pertanyaan Pertama',
    rating_options: 'Rentang Rating',
    file_options: 'Pengaturan Upload File',
    checkbox_options: 'Opsi Checkbox',
    radio_options: 'Opsi Radio Button',
    dropdown_options: 'Opsi Dropdown',
    options: 'Opsi',
    add_option: 'Tambah Opsi',
    no_options_added: 'Belum ada opsi yang ditambahkan',
    add_first_option: 'Tambah Opsi Pertama',
    // Visibility logic conditions
    condition_empty: 'Kosong',
    condition_not_empty: 'Tidak Kosong',
    condition_equal: 'Sama Dengan',
    condition_not_equal: 'Tidak Sama Dengan',
    condition_any_of: 'Salah Satu Dari',
    condition_greater: 'Lebih Besar',
    condition_less: 'Kurang Dari',
    condition_greater_or_equal: 'Lebih Besar atau Sama Dengan',
    condition_less_or_equal: 'Kurang Dari atau Sama Dengan',
    // File upload
    upload_multiple_files: 'Unggah Beberapa File',
    allowed_file_extensions: 'Ekstensi File yang Diperbolehkan',
    file_upload_condition_hint: 'Kondisi upload file - tidak perlu nilai',
    // Placeholders
    enter_option_value: 'Masukkan nilai opsi...',
    enter_number: 'Masukkan angka...',
    enter_value: 'Masukkan nilai...',
    option_number: 'Opsi',
    other_option: 'Opsi Lainnya',
    question_number: 'Pertanyaan',
    questions_will_be_added_here: 'Pertanyaan akan ditambahkan di sini',
    create_interview_form: 'Buat Form Interview',
    questions_will_be_added_here: 'Pertanyaan akan ditambahkan di sini',
    create_interview_form: 'Buat Form Interview',
    edit_interview_form: 'Edit Form Interview',
    create_offering_letter_form: 'Buat Form Surat Penawaran',
    edit_offering_letter_form: 'Edit Form Surat Penawaran',
    add_visibility_logic: 'Tambah Logika Visibilitas',
    visibility_logic: 'Logika Visibilitas',
    remove_logic: 'Hapus Logika',
    show_question_when: 'Tampilkan pertanyaan ini ketika:',
    select_question: 'Pilih pertanyaan...',
    condition: 'Kondisi:',
    value: 'Nilai:',
    action: 'Aksi:',
    show_this_question: 'Tampilkan pertanyaan ini',
    hide_this_question: 'Sembunyikan pertanyaan ini',
    logic_help_text: 'Pertanyaan ini akan {{action}} ketika kondisi terpenuhi.',
    min_rating: 'Rating Minimal',
    max_rating: 'Rating Maksimal',
    file_extensions_help: 'Pisahkan dengan koma. Contoh: .jpg, .png, .pdf, .doc, .xls',
    options_note: 'Catatan: Nilai otomatis disetel untuk cocok dengan label untuk kesederhanaan.',
    form_preview: 'Pratinjau Form',
    interview_form: 'Form Interview',
    no_survey_data: 'Data survei tidak tersedia',
    no_preview_data: 'Data pratinjau tidak tersedia',
    no_pages_added_yet: 'Belum ada halaman yang ditambahkan',
    add_first_page: 'Tambah Halaman Pertama',
    no_data_found: 'Tidak ada data ditemukan',
    refresh: 'Refresh',
    skill_description: 'Deskripsi Keahlian',
    qualification: 'Kualifikasi',
    required_skill: 'Keahlian Wajib',
    religion: 'Agama',
    choose_pic: 'Pilih Gambar',
    max_size_pic: 'Maksimal {{size}} MB',
    choose_profile_pic: 'Pilih Foto Profile',
    allowed_pic_file: 'Tipe file yang di perbolehkan',
    fullname: 'Nama Lengkap',
    nickname: 'Nama Panggilan',
    nik: 'NIK',
    no_hp: 'No. HP',
    nomor_hp: 'Nomor HP',
    alt_no_telp: 'Alternatif No. TLP',
    email_address: 'Alamat Email',
    social_media: 'Sosial Media',
    gender: 'Jenis Kelamin',
    weight: 'Berat Badan',
    height: 'Tinggi Badan',
    blood_type: 'Golongan Darah',
    birth_place_date: 'Tempat/Tanggal Lahir',
    religion: 'Agama',
    ethnic: 'Suku Bangsa',
    married_status: 'Status Perkawinan',
    total_child: 'Jumlah Anak',
    upload_cv: 'Upload CV',
    upload_ktp: 'Upload KTP',
    upload_npwp: 'Upload NPWP',
    upload_ijazah: 'Upload Ijazah & Transkrip Nilai Terakhir',
    upload_paklaring: 'Upload Surat Keterangan Kerja',
    upload_sk_domisili: 'Upload Surat Keterangan Domisili',
    upload_skck: 'Upload SKCK',
    upload_pas_photo: 'Upload Pas Foto 3x4',
    upload_bank_account: 'Upload Nomor Rekening Bank NISP',
    upload_kk: 'Upload Kartu Keluarga',
    upload_medical_checkup: 'Upload Pemeriksaan Medis',
    birth_place: 'Tempat Lahir',
    birth_date: 'Tanggal Lahir',
    stage: 'Tahap',
    reason: 'Alasan',
    choose_stage: 'Pilih Tahap',
    edit_password: 'Ubah Password',
    edit_email: 'Ubah Email',
    new_email: 'Email Baru',
    old_password: 'Password Lama',
    new_password: 'Password Baru',
    password_confirmation: 'Konfirmasi Password',
    academic_title: 'Gelar',
    // Question types
    question_type_text: 'Teks',
    question_type_date: 'Tanggal',
    question_type_datetime: 'TanggalWaktu',
    question_type_number: 'Angka',
    question_type_rating: 'Rating',
    question_type_checkbox: 'Checkbox',
    question_type_radiogroup: 'Radio Button',
    question_type_dropdown: 'Dropdown',
    question_type_file: 'File',
    // Question categories
    question_category_competency: 'Kompetensi',
    question_category_organizational_fit: 'Kesesuaian Organisasi',
    // Rating stars
    star_singular: 'Bintang',
    star_plural: 'Bintang',
    remove_option: 'Hapus opsi',
    variable_bank: 'Bank Variable',
    select_variable_to_insert: 'Pilih variable untuk disisipkan ke dalam teks',
    insert_variable: 'Sisipkan Variable',
    variables: 'Variable',
  },

  button: {
    login: 'Masuk',
    register: 'Daftar',
    learn_more: 'Learn More',
    send_verification_link: 'Send Verification Link',
    send: 'Kirim',
    save: 'Simpan',
    update: 'Ubah',
    cancel: 'Batal',
    submit: 'Submit',
    save_logo: 'Simpan Logo',
    add_new: 'Tambah Baru',
    delete: 'Hapus',
    reset: 'Reset',
    reset_password: 'Reset Password',
    search: 'Cari',
    filter: 'Filter',
    archive: 'Arsipkan',
    preview: 'Pratinjau',
    apply: 'Lamar',
    share: 'Bagikan',
    detail: 'Detail',
    see: 'Lihat',
    login: 'Masuk',
    create_new_account: 'Buat Akun Baru',
    upload: 'Upload',
    stage: 'Stage',
    reject: 'Reject',
    download: 'Download',
    send_task: 'Send Task',
    send_message: 'Send Message',
    edit: 'Ubah',
    yes: 'Ya',
    no: 'Tidak',
    export: 'Ekspor',
    edit_password: 'Ubah Password',
    edit_email: 'Ubah Email',
    activate: 'Aktifkan',
    previous: 'Kembali',
    next: 'Selanjutnya',
    continue: 'Lanjut',
    hire: 'Hire',
    send_offer: 'Kirim Penawaran',
    close: 'Tutup',
  },

  profile_tab: {
    profile: 'Identitas Pribadi',
    family: 'Keluarga',
    experience: 'Pendidikan & Pekerjaan',
    health: 'Riwayat Kesahatan',
    interest: 'Peminatan',
    other: 'Informasi Lain',
    reference: 'Referensi & Pernyataan',
    document: 'Dokumen',
    document_list: 'Daftar Dokumen',
  },

  stage: {
    received: 'Lamaran Diterima',
    send_task: 'Send Task',
    task_sent: 'Task Sent',
    rejected: 'Ditolak',
    declined: 'Menolak',
    for_interview: 'Tahap Interview',
    induction: 'Induksi',
    offered: 'Penawaran',
    hired: 'Diterima',
    application_sent: 'Permohonan Lamaran Telah Terkirim',
    task_received: 'Task Received',
    interview_scheduled: 'Terjadwal Interview',
    offering: 'Offering',
    for_test: 'Tahap Test',
    administration: 'Administrasi',
    input_offer: 'Input Penawaran',
  },

  application: {
    offered_amount: 'Nominal gaji yang ditawarkan',
    offer_sent: 'Penawaran terkirim',
  },

  role: {
    superadmin: 'Superadmin',
    admin: 'Admin',
    candidate: 'Kandidat',
  },

  sosmed: {
    ig: 'Instagram',
    tw: 'Twitter',
    fb: 'Facebook',
    yt: 'Youtube',
  },

  gender: {
    f: 'Wanita',
    m: 'Pria',
  },

  http: {
    request_failed: 'Request failed. there something wrong',
  },

  toast: {},

  passwords: {
    sent: 'Email terkirim',
    reset: 'Password berhasil direset',
    throttled: 'Mohon tunggu sebelum mengirim email lagi',
    token: 'Token reset password invalid',
    user: 'User tidak ditemukan',
  },

  files: {
    ktp: 'KTP',
    npwp: 'NPWP',
    ijazah: 'Ijazah & Transkrip Nilai Terakhir',
    paklaring: 'Surat Keterangan Kerja',
    sk_domisili: 'Surat Keterangan Domisili',
    skck: 'SKCK',
    pas_photo: 'Pas Foto 3x4',
    kk: 'Kartu Keluarga',
    bank_account: 'Nomor Rekening Bank NISP',
    medical_checkup: 'Pemeriksaan Medis',
  },

  date: {
    date: 'Tanggal',
    day: 'Hari',
    month: 'Bulan',
    year: 'Tahun',
    days: 'Hari',
    months: 'Bulan',
    years: 'Tahun',
  },

  // general translations
  name: 'Nama',
  last_login: 'Last login',
  birthday: 'Birthday',
  full_name: 'Full name',
  first_name: 'First name',
  last_name: 'Last name',
  username: 'Username',
  email: 'Email',
  phone: 'Phone',
  password: 'Password',
  password_confirmation: 'Konfirmasi Password',
  forgot_password: 'Lupa Password?',
  forgot_password_instruction: 'Masukkan email dan ikuti instruksi untuk reset password',
  login_as: 'Login As',
  login_success: 'Login Success',
  login_failed: 'Login Failed',
  register_success: 'Register Success',
  register_failed: 'Register Failed',
  description: 'Deskripsi',
  add_new: 'Tambah Baru',
  update: 'Ubah',
  delete: 'Hapus',
  saved: 'Tersimpan',
  other_jobs: 'Lowongan Pekerjaan Lain',
  link_copied: 'Link Copied!',
  see_all_jobs: 'Lihat Semua Lowongan Kerja',
  or: 'Atau',
  login_failed: 'Login Failed',
  login_success: 'Login Success',
  update_profile: 'Update Profile',
  location: 'Lokasi',
  contact: 'Kontak',
  website: 'Website',
  vision: 'Visi',
  mission: 'Misi',
  profile: 'PROFILE {{name}}',
  apply_for: 'Melamar Untuk',
  reject: 'Reject',
  send_task: 'Send Task',
  reset_password: 'Reset Password',
  edit: 'Ubah',
  page: 'Halaman',
  from: 'dari',
  are_you_sure_to_logout: 'Apakah anda yakin ingin keluar?',
  logout_success: 'Logout Success',
  reason: 'Reason',
  archived: 'Archived',
  see_all: 'Lihat Semua',
  hire: 'Hire',
  are_you_sure: 'Apakah anda yakin?',
  confirmation: 'Konfirmasi',
  time: 'Jam',
  place: 'Tempat',
  induction_date: 'Tanggal Induksi',
  induction_notes: 'Keterangan Induksi',
  interview_date: 'Tanggal Interview',
  interview_notes: 'Keterangan Interview',
  interview_reschedule_date: 'Tanggal Reschedule Interview',
  interview_reschedule_request: 'Tidak bisa interview pada tanggal',
  waiting_interview_reschedule: 'Menunggu reschedule interview',
  rejection_reason: 'Alasan penolakan',
  offered_status: 'Status Penerimaan',
  accept: 'Ya',
  decline: 'Tidak',
  reason: 'Alasan',
  reason_reject: 'Alasan Penolakan Interview',
  reason_reschedule: 'Alasan Ganti Jadwal Interview',
  cannot_empty: ' tidak boleh kosong',
  times_applied: 'Banyak Lamaran',
  offering: 'Penawaran',
  offer_amount: 'Nominal Penawaran',
  job_level: 'Level Pekerjaan',
  position: 'Posisi',
  position_alt: 'Jabatan',
  Unit: 'Unit',
  'Unit Utama': 'Unit Utama',
  penempatan: 'Penempatan',
  tunjangan_tempat_tinggal: 'Tunjangan Tempat Tinggal',
  tanggal_training: 'Tanggal Training',
  contract_type: 'Jenis Kontrak',
  contract_date_start: 'Tanggal Mulai Kontrak',
  contract_date_end: 'Tanggal Berakhir Kontrak',
  contract_duration: 'Durasi Kontrak',
  salary_amount: 'Nominal Gaji',

  offer_deadline: 'Batas Tanggal Penawaran',
  character: 'Karakter',
  employee_application_submission: 'Pengajuan Permohonan Pegawai',
  loading: 'Memuat...',
  active: 'Aktif',
  inactive: 'Tidak Aktif',
  
  // Modal translations
  modal_title_candidate_detail_all_stages: 'Detail Candidate - Semua Stage',
  information_application: 'Informasi Lamaran',
  subtitle_application_data: 'Data lengkap penerimaan lamaran',
  candidate_name: 'Nama Kandidat',
  job_position_label: 'Posisi Jabatan',
  job_posting: 'Lowongan Kerja',
  application_time: 'Waktu Lamaran',
  subtitle_application_time: 'Informasi waktu pengajuan lamaran',
  status_ok: 'OK',
  application_received_by_system: 'Lamaran diterima oleh sistem',
  candidate_not_entered_interview_stage: 'Kandidat belum memasuki tahap interview.',
  no_interview_schedule: 'Belum ada jadwal interview',
  interview_label: 'Interview',
  interview_detail: 'Detail Interview',
  interview_form_tab: 'Form Interview',
  interview_information: 'Informasi Interview',
  interview_type: 'Tipe Interview',
  interview_type_online: 'Online',
  interview_type_offline: 'Offline',
  interview_stage: 'Tahap Interview',
  interviewer_name: 'Nama Interviewer',
  interview_date: 'Tanggal Interview',
  interview_time: 'Waktu Interview',
  interview_link: 'Link Interview',
  interview_place: 'Tempat Interview',
  interview_status: 'Status Interview',
  interview_score: 'Skor Interview',
  interview_form: 'Form Interview',
  interview_form_answers: 'Jawaban form interview',
  no_interview_form_assigned: 'Form interview belum ditetapkan untuk interview ini',
  interviewer_notes: 'Catatan Interviewer',
  interviewer_label: 'Interviewer',
  candidate_not_received_offer: 'Kandidat belum menerima penawaran.',
  offer_status: 'Status Penawaran',
  response_time: 'Waktu Merespon',
  offer_date_given: 'Tanggal Penawaran Diberikan',
  offer_data_incomplete: 'Data penawaran belum lengkap. Harap isi form penawaran terlebih dahulu.',
  administration_stage: 'Stage Administrasi',
  candidate_in_administration_process: 'Kandidat sedang dalam proses administrasi.',
  candidate_not_entered_administration_stage: 'Kandidat belum memasuki tahap administrasi.',
  administration_documents: 'Dokumen Administrasi',
  no_administration_documents: 'Tidak ada dokumen administrasi',
  download_files: 'Unduh Berkas',
  candidate_not_entered_induction_stage: 'Kandidat belum memasuki tahap induksi.',
  no_induction_schedule: 'Belum ada jadwal induksi',
  induction_schedule_detail: 'Detail Jadwal Induksi',
  induction_type: 'Jenis Induksi',
  induction_name: 'Nama Induksi',
  date: 'Tanggal',
  time: 'Waktu',
  location: 'Lokasi',
  induction_guide: 'Pengantar',
  notes: 'Catatan',
  status: 'Status',
  accepted: 'Diterima',
  rejected: 'Ditolak',
  pending_confirmation: 'Menunggu Konfirmasi',
  rejection_reason: 'Alasan Penolakan',
  contract_detail: 'Detail Kontrak',
  candidate_not_contracted: 'Kandidat belum dikontrak.',
  rejection_status: 'Status Ditolak',
  rejection_information: 'Informasi detail penolakan kandidat',
  date_not_recorded: 'Tanggal tidak tercatat',
  candidate_rejected: 'Kandidat ditolak',
  no_reason_recorded: 'Tidak ada alasan yang dicatat',
  offer_rejection_status: 'Status Menolak Penawaran',
  offer_rejection_information: 'Informasi penolakan penawaran dari kandidat',
  candidate_rejected_offer: 'Kandidat menolak penawaran',
  stage_content_unavailable: 'Konten stage tidak tersedia',
  badge_current: 'Current',
  unknown: 'Unknown',
  position_label: 'Posisi:',
  posting_label: 'Lowongan:',
  school_label: 'Sekolah:',
  timeline: 'Timeline',
  loading_job_positions: 'Memuat posisi pekerjaan...',
  per_page: 'Per Halaman',
  date_label: 'Tanggal',
  mark_as_read: 'Tandai Sebagai Dibaca',
  unread: 'Belum Dibaca',
  read: 'Dibaca',
  mark_all_as_read: 'Tandai Semua Sebagai Dibaca',
  mark_all_as_read_confirm: 'Apakah anda yakin ingin menandai semua notifikasi sebagai dibaca?',
  notification_empty: 'Tidak ada notifikasi',
  confirm: 'Konfirmasi',
  cancel: 'Batal',
  contract_information_label: 'Informasi Detail Kontrak',
  contract_status: 'Status Kontrak',
  hired_confirmation: 'Konfirmasi Perekrutan',
  hired_status: 'Diterima / Dikontrak',
  employment_confirmation: 'Konfirmasi Ketenagakerjaan',
  candidate_successfully_hired: 'Kandidat Berhasil Direkrut',
  congratulations_hired: 'Selamat! Anda Berhasil Diterima',
  welcome_to_team: 'Selamat datang di tim kami!',
};

export default langID;
